import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  buttonsStyle,
  dateFormatter,
  substringFormatter,
} from "../../../components/tables/table";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { deleteLeatVenta, getLeatVentas, updateLeatVenta, markLeatVentasAsRead, updateLeatVentasByEmail } from "../../../../api/leatVenta";
import {
  Button,
  makeStyles,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import PrintIcon from "@material-ui/icons/Print";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import { shallowEqual, useSelector } from "react-redux";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getRelojes } from "../../../../api/reloj";
import { getModeloById } from "../../../../api/modelo";
import { SERVER_URL } from "../../../../api";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

function buildWhatsAppUrl(phone, text) {
  if (!phone) return null;
  const digits = String(phone).replace(/\D/g, "");
  const num = digits.startsWith("34") ? digits : digits.length <= 9 ? "34" + digits : digits;
  const base = `https://wa.me/${num}`;
  if (text) return `${base}?text=${encodeURIComponent(text)}`;
  return base;
}

function WhatsAppIcon({ style = {} }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#25D366" style={{ verticalAlign: "middle", ...style }} aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

function getData(leatVentas) {
  if (!Array.isArray(leatVentas)) {
    console.log("[LeatVentasPage getData] input not array:", typeof leatVentas);
    return [];
  }
  const data = [];
  console.log("[LeatVentasPage getData] input length:", leatVentas.length);

  for (let i = 0; i < leatVentas.length; i++) {
    const raw = leatVentas[i];
    if (raw == null) continue;

    const elem = {};
    elem.nombre = [raw.nombre, raw.apellido].filter(Boolean).join(" ").trim() || "-";
    elem.apellido = raw.apellido != null ? String(raw.apellido) : "";
    elem.email = raw.email != null ? String(raw.email) : "";
    elem.phone = raw.phone != null ? String(raw.phone) : "";
    elem.ciudad = raw.ciudad != null ? String(raw.ciudad) : "";

    // Marca y modelo: puede ser objeto populado, ObjectId, texto manual (marcaManual/modeloManual) o vacío
    let marcaText = "-";
    let modeloNombreText = "-";
    let modeloText = "-"; // combinado para tablas/compatibilidad
    const marcaManual = raw.marcaManual != null ? String(raw.marcaManual).trim() : "";
    const modeloManual = raw.modeloManual != null ? String(raw.modeloManual).trim() : "";
    if (marcaManual || modeloManual) {
      marcaText = marcaManual || "-";
      modeloNombreText = modeloManual || "-";
      modeloText = [marcaManual, modeloManual].filter(Boolean).join(" / ") || (marcaManual || modeloManual || "-");
    } else {
      const modeloValue = raw.modelo;
      if (modeloValue != null) {
        if (typeof modeloValue === "object" && modeloValue !== null && !Array.isArray(modeloValue)) {
          const marcaNombre = modeloValue.marca && typeof modeloValue.marca === "object"
            ? (modeloValue.marca.nombre || modeloValue.marca.name || "")
            : "";
        const modeloNombre = modeloValue.nombre || modeloValue.name || "";
        const parts = [marcaNombre, modeloNombre].filter(Boolean);
          marcaText = marcaNombre ? String(marcaNombre).trim() : "-";
          modeloNombreText = modeloNombre ? String(modeloNombre).trim() : "-";
        modeloText = parts.length > 0 ? parts.join(" ") : "-";
      } else if (typeof modeloValue === "string") {
          modeloText = modeloValue.trim() || "-";
          // No tenemos marca en este caso, guardamos el texto en "Modelo"
          marcaText = "-";
          modeloNombreText = modeloText;
      } else {
        modeloText = String(modeloValue);
          marcaText = "-";
          modeloNombreText = modeloText;
        }
      }
    }
    elem.marca = marcaText;
    elem.modeloNombre = modeloNombreText;
    elem.modelo = modeloText;
    
    elem.sku = raw.sku != null && String(raw.sku).trim() !== "" ? String(raw.sku).trim() : "-";
    elem.message = raw.message != null ? String(raw.message) : "";
    elem.landing = raw.landing != null ? String(raw.landing) : "";
    elem.tasacionInfo = raw.tasacionInfo != null ? String(raw.tasacionInfo) : "";
    elem.tasacionAntesRefinar = raw.tasacionAntesRefinar || null;
    elem.tasacionDespuesRefinar = raw.tasacionDespuesRefinar || null;
    elem.tasacionEstado = raw.tasacionEstado ?? (() => {
      const m = (raw.tasacionInfo || "").match(/Estado:\s*(\S+)/i);
      return m ? m[1].trim() : null;
    })();
    elem.tasacionEstuche = raw.tasacionEstuche ?? (() => {
      const m = (raw.tasacionInfo || "").match(/Estuche:\s*(S[ií]|No)/i);
      return m ? /s[ií]/i.test(m[1]) : null;
    })();
    elem.tasacionDocumentos = raw.tasacionDocumentos ?? (() => {
      const m = (raw.tasacionInfo || "").match(/Documentos:\s*(S[ií]|No)/i);
      return m ? /s[ií]/i.test(m[1]) : null;
    })();
    elem.createdAt = raw.createdAt;
    elem.images = Array.isArray(raw.images) ? raw.images : [];
    elem.originalPaths = Array.isArray(raw.originalPaths) ? raw.originalPaths : [];
    elem._id = raw._id;
    elem.id = raw._id != null ? String(raw._id) : (raw.id != null ? String(raw.id) : `row-${i}`);
    elem.read = raw.read === true;
    elem.desdeTasacion = raw.desdeTasacion === true;
    elem.idTasacion = raw.idTasacion || raw.logTasacionId || null;
    elem.estadoLead = raw.estadoLead || "nuevo";
    elem.notasLead = raw.notasLead != null ? String(raw.notasLead) : "";
    elem.fechaContacto = raw.fechaContacto;
    data.push(elem);
  }
  console.log("[LeatVentasPage getData] output rows:", data.length);
  return data;
}

/** Extrae min/avg/max de tasacionInfo (formato AfinarCotizacion o backend) */
function parsePreciosFromTasacionInfo(tasacionInfo) {
  if (!tasacionInfo || typeof tasacionInfo !== "string") return { min: null, avg: null, max: null };
  const raw = tasacionInfo;
  let min = null, avg = null, max = null;
  // Formato AfinarCotizacion: "Precio mínimo estimado: 15014.09 €" etc.
  const mMín = raw.match(/Precio mínimo estimado:\s*([\d.,]+)\s*€?/i);
  const mMedio = raw.match(/Precio medio estimado:\s*([\d.,]+)\s*€?/i);
  const mMáx = raw.match(/Precio máximo estimado:\s*([\d.,]+)\s*€?/i);
  if (mMín) min = parseFloat(String(mMín[1]).replace(",", "."));
  if (mMedio) avg = parseFloat(String(mMedio[1]).replace(",", "."));
  if (mMáx) max = parseFloat(String(mMáx[1]).replace(",", "."));
  // Formato backend: "min 15014.09€ / medio 15795.1€ / max 16607.5€" o "Tasación: min X€ / medio Y€ / max Z€"
  if (min == null || avg == null || max == null) {
    const mMin = raw.match(/\bmin\s+([\d.,]+)\s*€/i);
    const mMed = raw.match(/\bmedio\s+([\d.,]+)\s*€/i);
    const mMax = raw.match(/\bmax\s+([\d.,]+)\s*€/i);
    if (mMin && min == null) min = parseFloat(String(mMin[1]).replace(",", "."));
    if (mMed && avg == null) avg = parseFloat(String(mMed[1]).replace(",", "."));
    if (mMax && max == null) max = parseFloat(String(mMax[1]).replace(",", "."));
  }
  return { min: min ?? null, avg: avg ?? null, max: max ?? null };
}

function groupByEmail(rawList) {
  if (!Array.isArray(rawList) || rawList.length === 0) return [];
  const transformed = getData(rawList);
  const byEmail = {};
  rawList.forEach((raw, i) => {
    const elem = transformed[i];
    if (!elem) return;
    const key = String(elem.email || "").toLowerCase().trim() || "__sin_email__";
    if (!byEmail[key]) {
      byEmail[key] = {
        emailKey: key,
        email: elem.email || "",
        nombre: elem.nombre || "-",
        phone: elem.phone || "",
        items: [],
        rawItems: [],
        estadoLead: elem.estadoLead || "nuevo",
        notasLead: elem.notasLead != null ? String(elem.notasLead) : "",
        fechaContacto: elem.fechaContacto,
      };
    }
    byEmail[key].items.push(elem);
    byEmail[key].rawItems.push(raw);
  });
  return Object.values(byEmail).sort((a, b) => (a.email || "").localeCompare(b.email || ""));
}

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  printOnly: {
    display: "none !important",
  },
  "@global": {
    "@media print": {
      /* Mostrar logo en impresión */
      ".leatventa-print-logo": { display: "block !important" },
      /* Ocultar toda la app excepto el diálogo */
      "#root": { display: "none !important" },
      ".MuiBackdrop-root": { display: "none !important" },
      /* Ocultar botones Imprimir y Cerrar */
      ".MuiDialogActions-root": { display: "none !important" },
      /* Diálogo limpio para impresión */
      ".MuiDialog-paper": {
        boxShadow: "none !important",
        maxHeight: "none !important",
      },
      /* Contenido del diálogo: sin recorte para que las fotos salgan completas */
      ".MuiDialogContent-root": {
        overflow: "visible !important",
        maxHeight: "none !important",
      },
      /* Imágenes adjuntas: mostrar foto completa, sin recorte (object-fit contain + overflow visible) */
      ".leatventa-print-images .leatventa-print-img-wrap": {
        overflow: "visible !important",
        minHeight: "200px !important",
      },
      ".leatventa-print-images .leatventa-print-img-wrap img": {
        objectFit: "contain !important",
        width: "100% !important",
        height: "auto !important",
        maxHeight: "none !important",
      },
      /* Sin encabezados/pies de página del navegador */
      "@page": { margin: "0.8cm", size: "auto" },
    },
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function LeatVentasPage() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [leatVenta, setLeatVenta] = useState({});
  const [leatVentaId, setLeatVentaId] = useState("");
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsItem, setDetailsItem] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [userFilter, setUserFilter] = useState("Todos");
  const [estadoLeadFilter, setEstadoLeadFilter] = useState("Todos");
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [previewImageIndex, setPreviewImageIndex] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [originalPreviewUrl, setOriginalPreviewUrl] = useState(null);
  const [markingAllRead, setMarkingAllRead] = useState(false);
  const history = useHistory();
  const classes = useStyles();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  // Formatter para asegurar que modelo siempre sea string
  const modeloFormatter = (cell) => {
    if (!cell) return "-";
    if (typeof cell === "string") return cell;
    if (typeof cell === "object") {
      // Si es un objeto, intentar extraer nombre
      const marcaNombre = cell?.marca?.nombre || cell?.marca?.name || "";
      const modeloNombre = cell?.nombre || cell?.name || "";
      const parts = [marcaNombre, modeloNombre].filter(Boolean);
      return parts.length > 0 ? parts.join(" ") : "-";
    }
    return String(cell);
  };

  const ESTADO_LEAD_LABELS = {
    nuevo: "Nuevo",
    contactado: "Contactado",
    interesado: "Interesado",
    no_interesado: "No interesa",
    oferta_enviada: "Oferta enviada",
    cerrado: "Cerrado",
  };

  const openDetailFromItem = (item, rawItem) => {
    const detail = {
      ...item,
      apellido: rawItem?.apellido ?? item.apellido ?? "",
      phone: rawItem?.phone ?? item.phone ?? "",
      images: rawItem?.images ?? item.images ?? [],
      originalPaths: rawItem?.originalPaths ?? item?.originalPaths ?? [],
      estadoLead: rawItem?.estadoLead ?? item.estadoLead ?? "nuevo",
      notasLead: rawItem?.notasLead != null ? String(rawItem.notasLead) : (item.notasLead ?? ""),
      fechaContacto: rawItem?.fechaContacto ?? item.fechaContacto,
    };
    setDetailsItem(detail);
    setDetailsOpen(true);
  };

  const updateClientCrm = (emailKey, email, payload, updateLocal) => {
    updateLeatVentasByEmail(email, payload)
      .then(() => {
        alertSuccess("Seguimiento actualizado");
        if (updateLocal) {
          setData((prev) =>
            prev.map((item) =>
              item.email && String(item.email).trim().toLowerCase() === emailKey
                ? { ...item, ...payload }
                : item
            )
          );
          setFilteredData((prev) =>
            prev.map((item) =>
              item.email && String(item.email).trim().toLowerCase() === emailKey
                ? { ...item, ...payload }
                : item
            )
          );
        }
      })
      .catch((err) => alertError({ error: err, customMessage: "Error al guardar" }));
  };

  const tableData = React.useMemo(() => {
    const grouped = groupByEmail(Array.isArray(filteredData) ? filteredData : []);
    const withMeta = grouped.map((g) => ({
      ...g,
      id: g.emailKey,
      mensajesCount: g.items.length,
      lastDate: g.items.length
        ? new Date(Math.max(...g.items.map((i) => new Date(i.createdAt).getTime())))
        : null,
    }));
    // Orden por defecto: más nuevo a más viejo (por última fecha del grupo)
    return withMeta.sort((a, b) => {
      if (!a.lastDate) return 1;
      if (!b.lastDate) return -1;
      return new Date(b.lastDate).getTime() - new Date(a.lastDate).getTime();
    });
  }, [filteredData]);

  const columns = [
    { dataField: "nombre", text: "Nombre", sort: true },
    { dataField: "email", text: "Email", sort: true },
    { dataField: "phone", text: "Teléfono", sort: true },
    {
      dataField: "estadoLead",
      text: "Estado lead",
      sort: true,
      formatter: (cell, row) => (
        <select
          className="form-control form-control-sm"
          value={row.estadoLead || "nuevo"}
          style={{ maxWidth: 140 }}
          onChange={(e) => {
            const v = e.target.value;
            updateClientCrm(row.emailKey, row.email, {
              estadoLead: v,
              fechaContacto: v && v !== "nuevo" ? new Date().toISOString() : undefined,
            }, true);
          }}
        >
          {Object.entries(ESTADO_LEAD_LABELS).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
      ),
    },
    { dataField: "mensajesCount", text: "Nº mensajes", sort: true },
    { dataField: "lastDate", text: "Última fecha", formatter: dateFormatter, sort: true, style: { width: 95 }, headerStyle: { width: 95 } },
    {
      dataField: "id",
      text: "Acciones",
      style: { width: 100 },
      headerStyle: { width: 100 },
      formatter: (cell, row) => (
        <>
          {user?.role === "admin" && row.phone && (
            <Tooltip title="Abrir WhatsApp">
              <Button
                size="small"
                component="a"
                href={buildWhatsAppUrl(row.phone)}
                target="_blank"
                rel="noopener noreferrer"
                style={{ minWidth: 40, padding: 6 }}
              >
                <WhatsAppIcon />
              </Button>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const expandRow = {
    showExpandColumn: true,
    expandByColumnOnly: true,
    expandColumnRenderer: ({ expanded }) => (
      <Button size="small" variant="outlined" style={{ minWidth: 36, padding: "4px 8px" }}>
        {expanded ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />}
      </Button>
    ),
    renderer: (row) => (
      <div style={{ padding: "16px 24px", backgroundColor: "#f8f9fa", borderTop: "1px solid #dee2e6" }}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: "0.95rem", fontWeight: 600, marginBottom: 8, color: "#495057" }}>Notas del cliente</div>
          <textarea
            className="form-control"
            rows={4}
            defaultValue={row.notasLead ?? ""}
            placeholder="Añadir notas de seguimiento..."
            style={{ maxWidth: "100%", minWidth: 320, resize: "vertical", fontSize: "0.95rem" }}
            onBlur={(e) => {
              const v = e.target.value.trim();
              if (v === (row.notasLead ?? "")) return;
              updateClientCrm(row.emailKey, row.email, { notasLead: v }, true);
            }}
          />
        </div>
        <div style={{ fontSize: "0.9rem", fontWeight: 600, marginBottom: 12 }}>Mensajes de este cliente</div>
        <table className="table table-sm table-bordered" style={{ marginBottom: 0 }}>
          <thead>
            <tr>
              <th style={{ width: 105 }}>Fecha</th>
              <th style={{ width: 200 }}>Reloj</th>
              <th style={{ width: 180 }}>Landing</th>
              <th style={{ width: 140 }}>Tasación</th>
              <th>Mensaje</th>
              <th style={{ width: 250 }}></th>
            </tr>
          </thead>
          <tbody>
            {(row.items || []).map((item, idx) => {
              const raw = row.rawItems && row.rawItems[idx];
              const criterios = item.desdeTasacion
                ? [
                    item.tasacionEstado != null && (item.tasacionEstado.toLowerCase().includes("usado") ? "Usado" : "Nuevo"),
                    item.tasacionEstuche != null && (item.tasacionEstuche ? "Estuche" : null),
                    item.tasacionDocumentos != null && (item.tasacionDocumentos ? "Docs" : null),
                  ].filter(Boolean).join(", ") || "—"
                : "—";
    return (
                <tr key={item.id || idx}>
                  <td>{item.createdAt ? dateFormatter(item.createdAt) : "-"}</td>
                  <td style={{ maxWidth: 300 }}>
                    {item.sku && item.sku !== "-"
                      ? `${modeloFormatter(item.modelo)} Ref.: ${item.sku}`
                      : modeloFormatter(item.modelo)}
                  </td>
                  <td style={{ maxWidth: 180, wordBreak: "break-word", fontSize: "0.85rem" }}>
                    {item.landing || "-"}
                  </td>
                  <td style={{ maxWidth: 140, fontSize: "0.85rem" }}>{item.desdeTasacion ? criterios : "-"}</td>
                  <td style={{ maxWidth: 280 }}>{substringFormatter(item.message)}</td>
                  <td>
            <Button
                      size="small"
              variant="outlined"
              color="primary"
              startIcon={<VisibilityIcon />}
              onClick={async () => {
                        openDetailFromItem(item, raw);
                        if (item.id) {
                          try {
                            await updateLeatVenta(item.id, { read: true });
                            setData((prev) => prev.map((it) => (it._id === item.id ? { ...it, read: true } : it)));
                            setFilteredData((prev) => prev.map((it) => (it._id === item.id ? { ...it, read: true } : it)));
                            window.dispatchEvent(new Event("refreshUnreadCounts"));
                          } catch (_) {}
                        }
                      }}
                    >
                      Ver detalle
            </Button>
                    {user?.role === "admin" && (
                      <Tooltip title="Eliminar">
              <Button
                size="small"
                          style={{ ...buttonsStyle, marginLeft: 4 }}
                onClick={() => {
                            setLeatVenta({ _id: item.id, id: item.id });
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    ),
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      console.log("[LeatVentasPage] fetchData start");
      try {
        const resLeatVentas = await getLeatVentas();
        console.log("[LeatVentasPage] getLeatVentas response:", {
          status: resLeatVentas?.status,
          dataIsArray: Array.isArray(resLeatVentas?.data),
          dataLength: Array.isArray(resLeatVentas?.data) ? resLeatVentas.data.length : "n/a",
          dataType: typeof resLeatVentas?.data,
          dataKeys: resLeatVentas?.data && typeof resLeatVentas.data === "object" && !Array.isArray(resLeatVentas.data) ? Object.keys(resLeatVentas.data) : null,
          firstItemKeys: Array.isArray(resLeatVentas?.data) && resLeatVentas.data[0] ? Object.keys(resLeatVentas.data[0]) : null,
        });
        const list = Array.isArray(resLeatVentas?.data)
          ? resLeatVentas.data
          : Array.isArray(resLeatVentas?.data?.data)
            ? resLeatVentas.data.data
            : [];
        console.log("[LeatVentasPage] list length:", list.length, "status:", resLeatVentas?.status);
        if (resLeatVentas?.status === 200) {
          setData(list);
          setFilteredData(list);
        } else {
          console.warn("[LeatVentasPage] status not 200, not setting data");
        }
      } catch (error) {
        console.error("[LeatVentasPage] fetch error:", error?.message, error?.response?.status, error?.response?.data);
        alertError({
          error: error,
          customMessage: "Could not get leatVentas.",
        });
        setData([]);
        setFilteredData([]);
      } finally {
        setLoading(false);
        setRefresh(false);
        console.log("[LeatVentasPage] fetchData end, loading=false");
      }
    };
    fetchData();
  }, [refresh]);

  useEffect(() => {
    let filtered = data;
    if (userFilter !== "Todos") {
      filtered = filtered.filter((leatVenta) => {
        const nombre = `${leatVenta.nombre || ""} ${leatVenta.apellido || ""}`.trim();
        const email = leatVenta.email || "";
        const displayName = nombre || email ? `${nombre}${email ? ` (${email})` : ""}` : "";
        return displayName === userFilter;
      });
    }
    if (estadoLeadFilter !== "Todos") {
      filtered = filtered.filter((item) => (item.estadoLead || "nuevo") === estadoLeadFilter);
    }
      setFilteredData(filtered);
  }, [userFilter, estadoLeadFilter, data]);

  // URL de la imagen original para "Ver original" (cuando hay originalPaths guardados para esta imagen)
  useEffect(() => {
    if (!previewOpen || previewImageIndex == null || !detailsItem?.originalPaths?.length) {
      setOriginalPreviewUrl(null);
      return;
    }
    const path = detailsItem.originalPaths[previewImageIndex];
    if (!path || typeof path !== "string") {
      setOriginalPreviewUrl(null);
      return;
    }
    const baseUrl = SERVER_URL.replace(/\/$/, "");
    const fullUrl = path.startsWith("http") ? path : `${baseUrl}${path.startsWith("/") ? path : `/${path}`}`;
    setOriginalPreviewUrl(fullUrl);
  }, [previewOpen, previewImageIndex, detailsItem?.originalPaths, detailsItem?.id]);

  return (
    <>
      <Card>
        <CardHeader title="Lista LeatVentas">
          <CardHeaderToolbar>
            <Button
              type="button"
              className="btn btn-light-primary btn-sm mr-2"
              onClick={async () => {
                try {
                  setMarkingAllRead(true);
                  await markLeatVentasAsRead();
                  setData((prev) => prev.map((it) => ({ ...it, read: true })));
                  setFilteredData((prev) => prev.map((it) => ({ ...it, read: true })));
                  window.dispatchEvent(new Event("refreshUnreadCounts"));
                  alertSuccess({ customMessage: "Todos los mensajes marcados como leídos." });
                } catch (err) {
                  alertError({ error: err, customMessage: "Error al marcar como leídos." });
                } finally {
                  setMarkingAllRead(false);
                }
              }}
              disabled={markingAllRead}
              startIcon={<DoneAllIcon />}
            >
              {markingAllRead ? "Marcando…" : "Marcar todos como leídos"}
            </Button>
            {selectedRows.length > 0 && (
              <Button
                type="button"
                className="btn btn-danger"
                onClick={() => setOpenConfirmDialog(3)}
                startIcon={<DeleteIcon />}
              >
                Borrar seleccionados ({selectedRows.length})
              </Button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "16px 24px", marginBottom: 16 }}>
            <div className="form-group mb-0">
              <label>Filtrar por cliente</label>
            <select
              className="form-control"
              value={userFilter}
              onChange={(e) => setUserFilter(e.target.value)}
              style={{ maxWidth: "300px" }}
            >
              <option value="Todos">Todos</option>
                {(() => {
                  const grouped = groupByEmail(data);
                  return grouped
                    .map((g) => `${g.nombre} (${g.email || ""})`.trim() || g.email || "-")
                    .filter(Boolean)
                    .sort()
                    .map((label) => (
                      <option key={label} value={label}>
                        {label}
                      </option>
                    ));
                })()}
              </select>
            </div>
            <div className="form-group mb-0">
              <label>Estado lead</label>
              <select
                className="form-control"
                value={estadoLeadFilter}
                onChange={(e) => setEstadoLeadFilter(e.target.value)}
                style={{ maxWidth: "200px" }}
              >
                <option value="Todos">Todos</option>
                {Object.entries(ESTADO_LEAD_LABELS).map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                </option>
              ))}
            </select>
            </div>
          </div>
          <Table 
            data={tableData}
            columns={columns} 
            expandRow={expandRow}
            rowClasses={(row) => (row.items && row.items.some((i) => i.read === false) ? "unread-row" : "")}
          />
          <Dialog
            open={detailsOpen}
            onClose={() => setDetailsOpen(false)}
            maxWidth="lg"
            fullWidth
            PaperProps={{
              style: { borderRadius: 12 },
            }}
          >
            <DialogTitle style={{ borderBottom: "1px solid #eee", paddingBottom: 16, fontSize: "1.25rem" }}>
              Detalles del mensaje de venta
            </DialogTitle>
            <DialogContent dividers className={classes.dialogContent} style={{ maxHeight: "80vh", overflowY: "auto", padding: "24px" }}>
              {/* Logo solo visible al imprimir - cabecera limpia */}
              <div
                className={`${classes.printOnly} leatventa-print-logo`}
                    style={{
                  marginBottom: 24,
                  paddingBottom: 16,
                  borderBottom: "1px solid #eee",
                }}
              >
                <img
                  src={toAbsoluteUrl("/media/logo/logo.png")}
                  alt="TuRelojYa"
                  style={{ maxWidth: 160, height: "auto", display: "block" }}
                />
              </div>
              {/* Tarjeta: Datos del cliente */}
              <div style={{
                backgroundColor: "#f8f9fa",
                borderRadius: 10,
                padding: "20px 24px",
                marginBottom: 20,
                border: "1px solid #e9ecef",
              }}>
                <h4 style={{ margin: "0 0 16px 0", color: "#495057", fontSize: "0.95rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Datos del cliente
                </h4>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "12px 24px" }}>
                  <div><span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Nombre</span><br /><span style={{ fontWeight: 500 }}>{detailsItem?.nombre || "-"}</span></div>
                  {detailsItem?.apellido && <div><span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Apellido</span><br /><span style={{ fontWeight: 500 }}>{detailsItem.apellido}</span></div>}
                  <div><span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Email</span><br /><span style={{ fontWeight: 500 }}>{detailsItem?.email || "-"}</span></div>
                  <div><span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Teléfono</span><br /><span style={{ fontWeight: 500 }}>{detailsItem?.phone || "-"}</span></div>
                {detailsItem?.ciudad && <div><span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Ciudad / población</span><br /><span style={{ fontWeight: 500 }}>{detailsItem.ciudad}</span></div>}
                  <div><span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Landing</span><br /><span style={{ fontWeight: 500, wordBreak: "break-word" }}>{detailsItem?.landing || "-"}</span></div>
                  <div><span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Fecha del mensaje</span><br /><span style={{ fontWeight: 500 }}>{detailsItem?.createdAt ? new Date(detailsItem.createdAt).toLocaleString("es-ES") : "-"}</span></div>
                </div>
              </div>

              {/* Tarjeta: Reloj (marca / modelo y Num Ref.) */}
              <div style={{
                backgroundColor: "#fff",
                borderRadius: 10,
                padding: "20px 24px",
                marginBottom: 20,
                border: "1px solid #e9ecef",
              }}>
                <h4 style={{ margin: "0 0 16px 0", color: "#495057", fontSize: "0.95rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Reloj
                </h4>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: "12px 24px" }}>
                  <div><span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Marca</span><br /><span style={{ fontWeight: 500 }}>{detailsItem?.marca || "-"}</span></div>
                  <div><span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Modelo</span><br /><span style={{ fontWeight: 500 }}>{detailsItem?.modeloNombre || "-"}</span></div>
                  <div><span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Num Ref.</span><br /><span style={{ fontWeight: 500, fontFamily: "monospace" }}>{detailsItem?.sku || "-"}</span></div>
                  <div>
                    <span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Origen</span>
                    <br />
                    <span style={{ fontWeight: 500 }}>
                      {detailsItem?.desdeTasacion
                        ? "Lead desde tasación"
                        : "Lead directo de venta"}
                    </span>
                  </div>
                  {detailsItem?.idTasacion && (
                    <div>
                      <span style={{ color: "#6c757d", fontSize: "0.85rem" }}>
                        ID Log tasación
                      </span>
                      <br />
                      <span
                        style={{
                          fontFamily: "monospace",
                          fontSize: "0.8rem",
                          wordBreak: "break-all",
                        }}
                      >
                        {detailsItem.idTasacion}
                      </span>
                    </div>
                  )}
                  {detailsItem?.desdeTasacion && (detailsItem.tasacionEstado != null || detailsItem.tasacionEstuche != null || detailsItem.tasacionDocumentos != null) && (
                    <div style={{ gridColumn: "1 / -1", marginTop: 8, padding: "12px 16px", backgroundColor: "#f0f7ff", borderRadius: 8, border: "1px solid #cce5ff" }}>
                      <div style={{ fontSize: "0.8rem", fontWeight: 600, color: "#004085", marginBottom: 8 }}>Criterios de tasación</div>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px 24px", fontSize: "0.9rem" }}>
                        {detailsItem.tasacionEstado != null && (
                          <span><strong>Usado:</strong> {detailsItem.tasacionEstado.toLowerCase().includes("usado") ? "Sí" : "No"}</span>
                        )}
                        {detailsItem.tasacionEstuche != null && (
                          <span><strong>Estuche:</strong> {detailsItem.tasacionEstuche ? "Sí" : "No"}</span>
                        )}
                        {detailsItem.tasacionDocumentos != null && (
                          <span><strong>Documentos:</strong> {detailsItem.tasacionDocumentos ? "Sí" : "No"}</span>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Tarjeta: Mensaje */}
              <div style={{
                backgroundColor: "#fff",
                borderRadius: 10,
                padding: "20px 24px",
                marginBottom: 20,
                border: "1px solid #e9ecef",
              }}>
                <h4 style={{ margin: "0 0 12px 0", color: "#495057", fontSize: "0.95rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Mensaje
                </h4>
                <div style={{ backgroundColor: "#f8f9fa", borderRadius: 8, padding: 16, whiteSpace: "pre-line", color: "#333", lineHeight: 1.6 }}>
                  {detailsItem?.message || "-"}
                </div>
              </div>

              {/* Tarjeta: Precio antes / Precio estimado (usar tasacionInfo como fuente de verdad para precio estimado) */}
              {(detailsItem?.tasacionAntesRefinar || detailsItem?.tasacionDespuesRefinar || detailsItem?.tasacionInfo) && (() => {
                const tAntes = detailsItem.tasacionAntesRefinar || {};
                const tDespuesRaw = detailsItem.tasacionDespuesRefinar || {};
                const tFromInfo = parsePreciosFromTasacionInfo(detailsItem.tasacionInfo);
                const tDespues = (tFromInfo.min != null || tFromInfo.avg != null || tFromInfo.max != null)
                  ? tFromInfo
                  : tDespuesRaw;
                const hasAntes = tAntes.min != null || tAntes.avg != null || tAntes.max != null;
                const hasDespues = tDespues.min != null || tDespues.avg != null || tDespues.max != null;
                if (!hasDespues) return null;
                const fmt = (v) => v != null && v !== "-" ? `${Number(v).toLocaleString("es-ES")} €` : "-";
                return (
                  <div style={{
                    backgroundColor: "#f0f7ff",
                    borderRadius: 10,
                    padding: "24px",
                    marginBottom: 20,
                    border: "1px solid #cce5ff",
                  }}>
                    <h4 style={{ margin: "0 0 16px 0", color: "#004085", fontSize: "1rem", fontWeight: 600, display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ width: 4, height: 24, backgroundColor: "#004085", borderRadius: 2 }} />
                      Precio antes y después de refinar
                    </h4>
                    <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
                      {hasAntes && (
                        <div style={{ flex: "1 1 180px", minWidth: 160 }}>
                          <div style={{ fontSize: "0.8rem", fontWeight: 600, color: "#6c757d", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.5px" }}>Precio antes de refinar</div>
                          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                            <div style={{ padding: "10px 14px", borderRadius: 8, backgroundColor: "#e7f3ff", textAlign: "center" }}>
                              <div style={{ fontSize: "0.7rem", color: "#6c757d" }}>Mín</div>
                              <div style={{ fontSize: "1rem", fontWeight: 600 }}>{fmt(tAntes.min)}</div>
                            </div>
                            <div style={{ padding: "10px 14px", borderRadius: 8, backgroundColor: "#e7f3ff", textAlign: "center" }}>
                              <div style={{ fontSize: "0.7rem", color: "#6c757d" }}>Medio</div>
                              <div style={{ fontSize: "1rem", fontWeight: 600 }}>{fmt(tAntes.avg)}</div>
                            </div>
                            <div style={{ padding: "10px 14px", borderRadius: 8, backgroundColor: "#e7f3ff", textAlign: "center" }}>
                              <div style={{ fontSize: "0.7rem", color: "#6c757d" }}>Máx</div>
                              <div style={{ fontSize: "1rem", fontWeight: 600 }}>{fmt(tAntes.max)}</div>
                            </div>
                          </div>
                        </div>
                      )}
                      {hasDespues && (
                        <div style={{ flex: "1 1 180px", minWidth: 160 }}>
                          <div style={{ fontSize: "0.8rem", fontWeight: 600, color: "#6c757d", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.5px" }}>Precio después de refinar</div>
                          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                            <div style={{ padding: "10px 14px", borderRadius: 8, backgroundColor: "#d4edda", textAlign: "center" }}>
                              <div style={{ fontSize: "0.7rem", color: "#6c757d" }}>Mín</div>
                              <div style={{ fontSize: "1rem", fontWeight: 600 }}>{fmt(tDespues.min)}</div>
                            </div>
                            <div style={{ padding: "10px 14px", borderRadius: 8, backgroundColor: "#d4edda", textAlign: "center" }}>
                              <div style={{ fontSize: "0.7rem", color: "#6c757d" }}>Medio</div>
                              <div style={{ fontSize: "1rem", fontWeight: 600 }}>{fmt(tDespues.avg)}</div>
                            </div>
                            <div style={{ padding: "10px 14px", borderRadius: 8, backgroundColor: "#d4edda", textAlign: "center" }}>
                              <div style={{ fontSize: "0.7rem", color: "#6c757d" }}>Máx</div>
                              <div style={{ fontSize: "1rem", fontWeight: 600 }}>{fmt(tDespues.max)}</div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })()}

              {/* Tarjeta: Detalles de la tasación (parseada y formateada) */}
              {detailsItem?.tasacionInfo && (() => {
                const raw = detailsItem.tasacionInfo;
                const lines = raw.split(/\n/).map((l) => l.trim()).filter(Boolean);
                const sections = [];
                let current = { title: null, items: [] };
                for (const line of lines) {
                  if (line.endsWith(":")) {
                    if (current.title || current.items.length) sections.push({ ...current });
                    current = { title: line.replace(/:$/, ""), items: [] };
                  } else if (line.includes(":")) {
                    const idx = line.indexOf(":");
                    current.items.push({ label: line.slice(0, idx).trim(), value: line.slice(idx + 1).trim() });
                  } else if (current.title) {
                    current.items.push({ label: null, value: line });
                  }
                }
                if (current.title || current.items.length) sections.push(current);

                return (
                  <div style={{
                    backgroundColor: "#f0f7ff",
                    borderRadius: 10,
                    padding: "24px",
                    marginBottom: 20,
                    border: "1px solid #cce5ff",
                  }}>
                    <h4 style={{ margin: "0 0 20px 0", color: "#004085", fontSize: "1rem", fontWeight: 600, display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ width: 4, height: 24, backgroundColor: "#004085", borderRadius: 2 }} />
                      Detalles de la tasación
                    </h4>
                    {sections.map((sec, i) => (
                      <div key={i} style={{ marginBottom: i < sections.length - 1 ? 20 : 0 }}>
                        {sec.title && (
                          <div style={{ fontSize: "0.8rem", fontWeight: 600, color: "#004085", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                            {sec.title}
                          </div>
                        )}
                        {sec.items.length > 0 && (
                          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: "10px 24px" }}>
                            {sec.items.map((item, j) => (
                              <div key={j} style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                {item.label != null && <span style={{ color: "#6c757d", fontSize: "0.8rem" }}>{item.label}</span>}
                                <span style={{ fontWeight: item.label != null ? 500 : 400, color: "#212529", fontSize: item.label === "Precio mínimo estimado" || item.label === "Precio medio estimado" || item.label === "Precio máximo estimado" ? "1rem" : "0.95rem" }}>
                                  {item.value}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                );
              })()}

              {/* Imágenes adjuntas */}
                {detailsItem?.images && detailsItem.images.length > 0 && (
                    <div
                  className="leatventa-print-images"
                      style={{
                    backgroundColor: "#fff",
                    borderRadius: 10,
                    padding: "20px 24px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <h4 style={{ margin: "0 0 16px 0", color: "#495057", fontSize: "0.95rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    Imágenes adjuntas ({detailsItem.images.length})
                  </h4>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 16 }}>
                      {detailsItem.images.map((imagePath, index) => {
                        let imageUrl = imagePath;
                        if (imagePath && !imagePath.startsWith("data:image") && !imagePath.startsWith("http")) {
                          const normalizedPath = imagePath.replace(/\\/g, '/');
                          imageUrl = `${SERVER_URL}${normalizedPath.startsWith("/") ? normalizedPath : `/${normalizedPath}`}`;
                        }
                        return (
                          <div
                            key={index}
                            style={{
                              position: "relative",
                            borderRadius: 10,
                              overflow: "hidden",
                              cursor: "pointer",
                            border: "1px solid #dee2e6",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                            transition: "box-shadow 0.2s ease",
                          }}
                          onClick={() => {
                            if (imageUrl) {
                              setPreviewImageUrl(imageUrl);
                              setPreviewImageIndex(index);
                              setOriginalPreviewUrl(null);
                              setPreviewOpen(true);
                            }
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)"; }}
                          onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)"; }}
                        >
                          <div className="leatventa-print-img-wrap" style={{ aspectRatio: "1", backgroundColor: "#f8f9fa" }}>
                            <img
                              src={imageUrl}
                              alt={`Imagen ${index + 1}`}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              onError={(e) => { e.target.src = "https://via.placeholder.com/200x200?text=Error"; }}
                            />
                          </div>
                          <div style={{ padding: "8px 12px", backgroundColor: "#f8f9fa", fontSize: "0.8rem", color: "#6c757d", textAlign: "center" }}>
                              Click para ampliar
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
            </DialogContent>
            <DialogActions style={{ padding: "16px 24px", borderTop: "1px solid #eee" }}>
              <Button
                onClick={() => window.print()}
                color="default"
                variant="outlined"
                startIcon={<PrintIcon />}
              >
                Imprimir
              </Button>
              <Button
                onClick={() => setDetailsOpen(false)}
                color="primary"
                variant="contained"
                autoFocus
              >
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>
          {/* Diálogo de previsualización de imagen grande */}
          <Dialog
            open={previewOpen}
            onClose={() => {
              setPreviewOpen(false);
              setPreviewImageIndex(null);
              setOriginalPreviewUrl(null);
            }}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>Vista previa de la imagen</DialogTitle>
            <DialogContent
              dividers
              style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#000" }}
            >
              {previewImageUrl && (
                <img
                  src={previewImageUrl}
                  alt="Vista previa"
                  style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
                />
              )}
            </DialogContent>
            <DialogActions>
              {false && originalPreviewUrl && (
                <Button
                  onClick={() => window.open(originalPreviewUrl, "_blank")}
                  color="primary"
                  variant="outlined"
                  style={{ marginRight: 8 }}
                >
                  Ver original
                </Button>
              )}
              <Button
                onClick={() => {
                  setPreviewOpen(false);
                  setPreviewImageIndex(null);
                  setOriginalPreviewUrl(null);
                }}
                color="primary"
                autoFocus
              >
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>
          <ConfirmDialog
            title={"¿Estás seguro de que quieres borrar este mensaje de venta?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              // Usar id o _id, dependiendo de qué esté disponible
              const idToDelete = leatVenta?._id || leatVenta?.id;
              if (!idToDelete) {
                alertError({
                  error: new Error("ID no encontrado"),
                  customMessage: "No se pudo encontrar el ID del mensaje de venta.",
                });
                return;
              }
              deleteLeatVenta(idToDelete)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Eliminado!",
                      customMessage: "Mensaje de venta eliminado correctamente.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se pudo eliminar el mensaje de venta.",
                  });
                });
            }}
          />
          <ConfirmDialog
            title={`¿Estás seguro de que quieres borrar ${selectedRows.length} elemento(s)?`}
            open={openConfirmDialog === 3}
            setOpen={setOpenConfirmDialog}
            onConfirm={async () => {
              try {
                // Borrar todos los elementos seleccionados
                const deletePromises = selectedRows.map((row) =>
                  deleteLeatVenta(row.id)
                );
                await Promise.all(deletePromises);
                
                alertSuccess({
                  title: "Eliminados!",
                  customMessage: `${selectedRows.length} elemento(s) eliminado(s) correctamente.`,
                });
                setSelectedRows([]);
                setRefresh(true);
              } catch (error) {
                alertError({
                  error: error,
                  customMessage: "Error al eliminar los elementos seleccionados.",
                });
              }
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
